export default __webpack_public_path__ + "static/media/mouse-left-click.34900629.png";